// extracted by mini-css-extract-plugin
export default {"listArtist":"ListArtist_listArtist__HSVcv","header":"ListArtist_header__-A19p"};